<template>
    <b-overlay :show="busy" rounded="sm">

        <b-card class="standardpage reports invoices border-none">
            <div class="availtable datatable">
                <b-card class="w-100pct">

                    <b-card-body class="py-0 px-0">

                        <b-tabs class="gridtabs" v-model="tabindex">
                            <b-tab>
                                <template #title>
                                    <div class="badgecontainer pr-2 mr-1">
                                        <i class="fa fa-repeat text-primary mr-1"></i>
                                        Amend
                                        <b-badge id="selection" variant="primary" class="edit_tab">
                                            {{ selection.length }}</b-badge>
                                        <b-tooltip target="selection" placement="bottom">{{ selection.length }}
                                            transaction(s)
                                            selected</b-tooltip>
                                    </div>


                                </template>
                                <p>
                                    <b-row>
                                        <b-col>
                                            <b-alert :show="true" variant="secondary">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6"> Amend multiple transactions in the Sales
                                                            Ledger.
                                                        </span></b-col></b-row>
                                            </b-alert></b-col>
                                    </b-row>
                                </p>

                            </b-tab>

                            <b-tab>
                                <template #title>
                                    <i class="fa fa-check-square-o text-primary mr-1"></i>
                                    Client/Supplier</template>

                                <p>
                                    <b-row>
                                        <b-col>
                                            <b-alert :show="true" variant="secondary">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6"> All transactions selected will be updated with
                                                            the following, Your
                                                            Ref/PO, SL
                                                            A/C, Event and BL A/C when you post the change. Leave empty
                                                            for no change.
                                                        </span></b-col></b-row>
                                            </b-alert></b-col>
                                    </b-row>
                                </p>
                                <p class="pt-0 px-0">
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Your Ref / PO" label-for="yourref" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="yourref"
                                                        placeholder="Your Ref / PO" size="sm"
                                                        :disabled="false"></b-form-input>
                                                    <span class="h5" v-text="'*'"></span>
                                                    <b-form-input type="text" v-model="booker" placeholder="BN"
                                                        size="sm" :disabled="false"
                                                        :style="'max-width: 50px'"></b-form-input>
                                                    <b-input-group-append>

                                                        <b-button size="sm" :disabled="false"
                                                            variant="outline-secondary"
                                                            @click="yourref = ''; booker = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>

                                        <!-- <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Booker *BN" label-for="booker" label-cols="12">
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="booker" placeholder="*BN"
                                                        size="sm" :disabled="false"></b-form-input>
                                                    <b-input-group-append>
                                                        <b-button size="sm" :disabled="false" variant="outline-secondary"
                                                            @click="booker = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col> -->

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                                                <treeselect placeholder="Select slac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="slac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Event" label-size="sm">
                                                <treeselect placeholder="Select event..." v-model="eventcode"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label-cols="12" label="Supplier BL A/C" label-size="sm">
                                                <treeselect placeholder="Select blac..."
                                                    searchPromptText="Type at least 3 chars..." v-model="blac"
                                                    :clearable="true" :async="true" :load-options="treeselect_loadBLAC"
                                                    :show-count="true" :flatten-search-results="true"
                                                    :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                                    :disabled="false">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        {{ node.raw.id }}
                                                    </div>
                                                </treeselect>
                                            </b-form-group>
                                        </b-col>

                                        <b-col cols="12" sm="12" md="12" xl="12">
                                            <b-form-group label="Notes" label-for="notes" label-cols="12">
                                                <b-form-textarea id="data" v-model="notes" placeholder="Notes" rows="6"
                                                    class="smalltextarea"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>

                                    </b-row>
                                </p>
                            </b-tab>

                            <b-tab>
                                <template #title>
                                    <i class="fa fa-check-square-o text-primary mr-1"></i>
                                    Analysis</template>
                                <p>
                                    <b-row>
                                        <b-col>
                                            <b-alert :show="true" variant="secondary">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6"> Paste a list of transactions to update
                                                            analysis values in the sales ledger.
                                                        </span></b-col></b-row>
                                            </b-alert></b-col>
                                    </b-row>


                                    <b-row class="mt-2" no-gutters>
                                        <b-col cols="6">
                                            <b-form-group>
                                                <b-form-checkbox-group id="segments_paste_selected"
                                                    v-model="analysis.paste_selected" :options="analysis.paste_options"
                                                    value-field="id" text-field="label"></b-form-checkbox-group>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="auto" class="text-right ml-auto">
                                            <b-row>
                                                <!-- <b-col cols="auto">
                                                    <b-link squared size="sm" variant="outline-primary"
                                                        @click="download()">
                                                        <i class="fa fa-download"></i>
                                                        Template
                                                    </b-link>
                                                </b-col>
                                                <b-col cols="auto">
                                                    <b-link size="sm" variant="outline-primary"
                                                        @click="analysis_saveit()">
                                                        <i class="fa fa-floppy-o"></i>
                                                        Save It
                                                    </b-link>
                                                </b-col> -->
                                                <b-col cols="auto">
                                                    <b-link size="sm" variant="outline-primary"
                                                        @click="analysis_headers()">
                                                        Headers
                                                    </b-link>
                                                </b-col>
                                                <b-col cols="auto">
                                                    <b-link size="sm" variant="outline-primary"
                                                        @click="analysis_clear()">
                                                        <i class="fa fa-eraser"></i>
                                                        Clear It
                                                    </b-link>
                                                </b-col>
                                                <b-col cols="auto">
                                                    <b-link size="sm" variant="outline-primary"
                                                        @click="analysis_paste_read()">
                                                        <i class="fa fa-magic"></i>
                                                        Read It
                                                    </b-link>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col cols="12">
                                            <b-form-group label-cols="12">
                                                <b-form-textarea id="data" v-model="analysis.paste"
                                                    placeholder="Paste analysis data" rows="6"
                                                    class="smalltextarea courier"></b-form-textarea>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                    <b-row no-gutters>
                                        <b-col cols="12">
                                            <d-table classdivtable="availtable datatable sheets" refid="analysis"
                                                :maxheight="200" :icon="analysis.icon" :tools="analysis.tools"
                                                :badges="analysis.badges" :fields="analysis.fields"
                                                :items="analysis.items" :showpages="false">
                                            </d-table>
                                        </b-col>
                                    </b-row>
                                    <b-row class="mt-2">
                                        <b-col>
                                            <b-alert :show="analysis.message ? true : false" :variant="'success'">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6">
                                                            {{ analysis.message }}
                                                        </span>
                                                    </b-col>
                                                </b-row>
                                            </b-alert>
                                        </b-col>
                                    </b-row>

                                </p>
                            </b-tab>

                            <b-tab>
                                <template #title>
                                    <i class="fa fa-plus-square text-primary mr-1"></i>
                                    Add/Change Fees</template>

                                <p>
                                    <b-row>
                                        <b-col>
                                            <b-alert :show="true" variant="secondary">
                                                <b-row align-v="center" no-gutters><b-col cols="auto mr-3">
                                                        <i class="fa fa-exclamation-circle fa-2x"></i></b-col>
                                                    <b-col>
                                                        <span class="h6"> This feature will add/change or remove a
                                                            ticketing fee (with checkbox) to
                                                            an invoice maintaining the overall invoice total.
                                                            The ticket cost will be reduced by the ticketing fee to
                                                            allow it to be added again
                                                            inclusive in the overall cost.
                                                            Leave empty for no change.
                                                        </span></b-col></b-row>
                                            </b-alert></b-col>
                                    </b-row>
                                </p>
                                <p class="pt-0 px-0">
                                    <b-row>
                                        <b-col cols="12" sm="6" md="4" xl="3">
                                            <b-form-group label="Ticketing Fee (per Ticket)" label-for="fees"
                                                label-cols="12">
                                                <b-input-group class="treeselect_all" style="left:133px; top:-13px">
                                                    <i id="ticketingfees" class="fa fa-info-circle text-black"></i>
                                                </b-input-group>
                                                <b-tooltip target="ticketingfees" triggers="hover" placement="top">
                                                    Enter the amount of the ticketing fee (per ticket). This will be
                                                    multiplied up by the number of
                                                    passengers travelling.
                                                </b-tooltip>
                                                <b-input-group>
                                                    <b-form-input type="text" v-model="fees"
                                                        placeholder="Ticketing Fee (per Ticket)" size="sm"
                                                        :disabled="removefees == true"></b-form-input>
                                                    <b-input-group-append>

                                                        <b-button size="sm" :disabled="false"
                                                            variant="outline-secondary" @click="fees = ''">
                                                            <i class="fa fa-remove"></i>
                                                        </b-button>
                                                    </b-input-group-append>
                                                </b-input-group>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>

                                    <b-row class="mt-4">
                                        <b-col cols="12" md="5">
                                            <b-form-checkbox class="z-0" id="removefees" v-model="removefees"
                                                name="removefees">
                                                <span>Remove Ticketing Fees</span>
                                            </b-form-checkbox>
                                        </b-col>
                                    </b-row>
                                    <!-- {{ removefees }} -->
                                </p>
                            </b-tab>

                        </b-tabs>

                    </b-card-body>
                    <b-card-footer class="nopadding mt-2">
                        <b-row no-gutters>
                            <b-col cols="auto" class="text-left">
                                <b-button squared size="sm" variant="primary" @click="saveit()"
                                    v-if="tabindex != 0 && user.permissions.includes('salesledger.save')"
                                    :disabled="postit_disabled">
                                    <i class="fa fa-check"></i>
                                    Post It
                                </b-button>
                            </b-col>
                            <b-col class="text-left ml-2 mt-1">
                                <div v-if="busy">
                                    <i class="fa fa-spinner fa-spin text-primary"></i>
                                </div>
                                <div v-else>
                                    <span v-html="message"></span>
                                </div>
                            </b-col>
                            <b-col class="text-right" cols="8">
                                <b-button squared size="sm" variant="secondary" @click="discard">
                                    <i class="fa fa-chevron-left pr-1"></i>
                                    Back
                                </b-button>
                            </b-col>
                        </b-row>
                        <b-row no-gutters class="mt-2">

                        </b-row>
                    </b-card-footer>
                </b-card>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

function tabToObjArr(text) {

    let raw = text.trim().split('"').join("")
    let allcols = raw.split("\t")

    let headers = raw.split("\n")[0].split("\t")
    let cb = headers.length - 1
    let cols = []
    for (let i = 0; i < allcols.length; i++) {
        if (i == cb) {
            let parts = allcols[i].trim().split("\n")
            for (let k = 0; k < parts.length; k++) {
                cols.push(parts[k].trim())
            }
            cb += headers.length - 1
        } else {
            cols.push(allcols[i].trim().split("\n").join(",").replace(/\s+/g, ' '))
        }
    }
    console.log('cols=', cols)

    cb = headers.length - 1
    let rows = []
    let item = {}
    let k = 0
    for (let i = 0; i < cols.length; i++) {
        if (i == cb) {
            item[headers[k]] = cols[i]
            rows.push(item)
            cb += headers.length
            item = {}
            k = 0
        } else {
            item[headers[k]] = cols[i]
            k += 1
        }
    }
    return rows;
}

export default {
    name: "SLAmend",
    async mounted() {
        await this.accessdenied();
    },
    data() {
        return {
            busy: false,
            tabindex: 0,
            debounce: 500,
            readonly: false,
            ticketno: [],
            date_at: {
                startDate: this.$moment().format("YYYY-MM-DD"),
                endDate: this.$moment().format("YYYY-MM-DD"),
            },
            yourref: null,
            booker: null,
            slac: null,
            blac: null,
            eventcode: null,
            notes: null,
            fees: null,
            removefees: false,
            surname: null,
            firstname: null,
            title: null,
            passenger: null,
            analysis: {
                icon: "fa fa-wpforms",
                paste: null,
                paste_selected: ["firstrowheader"],
                paste_options: [
                    { id: "firstrowheader", label: "First Row Headers", disabled: true },
                    // { id: "secondrowskip", label: "Second Row Skip" },
                    // { id: "filldown", label: "Fill Down" },
                ],
                message: null,
                fields: [
                    {
                        key: "icon",
                        label: "",
                        class: "w-50px text-right text-primary nowrap",
                    },
                    {
                        key: "invoiceno",
                        label: "TransactionNo [SL Tran Ref]",
                        class: "text-center",
                        sortable: true,
                    },
                    {
                        key: "analysis1",
                        label: "Analysis1 [SL Anal1]",
                        class: "text-center",
                        sortable: true,
                    },
                    {
                        key: "analysis2",
                        label: "Analysis2 [SL Anal2]",
                        class: "text-center",
                        sortable: true,
                    },
                ],
                items: []
            },
            message: null,
        };
    },
    watch: {
        surname: {
            immediate: true,
            async handler(newVal, oldVal) {
                this.passenger = newVal + "/" + this.firstname
            },
        },
        firstname: {
            immediate: true,
            async handler(newVal, oldVal) {
                this.passenger = this.surname + "/" + newVal
            },
        },
    },
    computed: {
        postit_disabled() {
            switch (this.tabindex) {
                case 0:
                    return true
                case 1:
                    return this.selection.length == 0 ? true : false
                case 2:
                    return false
                case 3:
                    return this.selection.length == 0 ? true : false
            }

        }
    },
    methods: {
        async accessdenied() {

        },
        async load() {
            this.invoiceno = []

            for (var i = 0; i < this.selection.length; ++i) {
                this.invoiceno.push(this.selection[i].invoiceno)
            }
        },


        analysis_paste_read() {

            let state = this.analysis;

            if (state.paste) {

                state.busy = true
                let rows = tabToObjArr(state.paste)
                console.log('rows=', rows)

                let rowstart = 1
                if (state.paste_selected.includes("secondrowskip")) {
                    rowstart += 1
                }

                // MAKE OBJECT ITEMS
                let items = []
                for (let i = rowstart; i < rows.length; i++) {
                    items.push(rows[i])
                }
                console.log('items', items)

                if (state.paste_selected.includes("filldown")) {
                    let lastitem = {}
                    for (let i = 0; i < items.length; i++) {
                        let item = items[i]
                        for (let prop in lastitem) {
                            if (!item[prop]) {
                                if (lastitem[prop]) {
                                    item[prop] = lastitem[prop]
                                }
                            }
                        }
                        lastitem = item
                    }
                }
                console.log('fill downs', rows)

                let found = null

                rows = []
                for (let i = 0; i < items.length; i++) {
                    let obj = items[i]

                    let target = {}

                    for (let prop in obj) {

                        try {
                            if (obj[prop]) {
                                let data = obj[prop].trim().toUpperCase()
                                let colname = prop.toLowerCase()

                                if (colname == 'invoice ref') {
                                    colname = "invoiceno"
                                }
                                if (colname == 'sl anal1' || colname == 'rb invoice' || colname == 'analysis1') {
                                    colname = "analysis1"
                                }
                                if (colname == 'sl anal2' || colname == 'analysis2') {
                                    colname = "analysis2"
                                }

                                target[colname] = data

                            }

                        } catch (error) {
                            console.log('error here', error)
                        }

                    }

                    rows.push(target)
                }
                console.log(rows)

                state.items = rows

                state.message = "Ready to update " + rows.length + " row(s)."

                state.busy = false
            }

        },
        async analysis_headers() {

            let state = this.analysis;

            let content = state.paste
            state.paste = "TransactionNo\tAnalysis1\tAnalysis2"
            if (content) {
                state.paste += content
            }
        },
        async analysis_clear() {
            let state = this.analysis;
            state.paste = ''
            state.items = []
            state.message = ''
        },

        async saveit() {
            this.busy = true;

            let variables = {}
            let rows = []

            switch (this.tabindex) {

                case 1:
                    for (var j = 0; j < this.selection.length; j++) {
                        let row = {
                            entry: this.selection[j].id,
                            yourref: this.yourref,
                            booker: this.booker,
                            slac: this.slac,
                            blac: this.blac,
                            eventcode: this.eventcode,
                            notes: this.notes,
                        }
                        rows.push(row);
                    }
                    variables.rows = rows
                    try {
                        const response = await this.$apollo.mutate({
                            mutation: gql`
                                mutation SL_save($rows: [SLTransaction_input]) {
                                    SL_save(rows: $rows) {
                                                id
                                            }
                                    }
                            `,
                            variables,
                        });
                        this.message = "<span class='text-primary'>Posted it.</span>";
                        this.analysis.message = ""
                        this.analysis.items = []

                    } catch (error) {
                        this.message = "<span class='text-danger'>" + error.message + "</span>";
                    }
                    break;

                case 2:
                    variables.rows = this.analysis.items
                    try {
                        const response = await this.$apollo.mutate({
                            mutation: gql`
                    mutation SL_save($rows: [SLTransaction_input]) {
                        SL_save(rows: $rows) {
                                    id
                                }
                        }
                            `,
                            variables,
                        });
                        this.message = "<span class='text-primary'>Posted it.</span>";
                        this.analysis.message = ""
                        this.analysis.items = []

                    } catch (error) {
                        this.message = "<span class='text-danger'>" + error.message + "</span>";
                    }
                    break;

                case 3:
                    for (var j = 0; j < this.selection.length; j++) {
                        let row = {
                            entry: this.selection[j].id,
                        }
                        rows.push(row);
                    }
                    variables.rows = rows
                    variables.options = JSON.stringify({
                        remove: this.removefees ? this.removefees : false,
                        fee: !this.removefees ? this.fees : null,
                    })

                    try {
                        const response = await this.$apollo.mutate({
                            mutation: gql`
                                mutation SL_fee($rows: [SLTransaction_input], $options:String) {
                                    SL_fee(rows: $rows, options: $options) {
                                                id
                                            }
                                    }
                            `,
                            variables,
                        });
                        this.message = "<span class='text-primary'>Posted it.</span>";

                    } catch (error) {
                        this.message = "<span class='text-danger'>" + error.message + "</span>";
                    }
                    break;

            }



            this.busy = false;
        },


    },
};
</script>